import BButton from './packages/BButton'

BButton.install = function(Vue) {
    Vue.component(BButton.name, BButton)
}

export default BButton
